export default {
    metro: {
        requests: {
            status: 'Status',
            states: {
                2: 'Draft',
                3: 'On approval',
                4: 'Approved',
                7: 'Approved',
                8: 'Rejected',
                9: 'Canceled'
            }
        },
        request: {
            draft: 'Draft',
            send: 'Sended',

            title: 'Recruitment request',
            structure: 'Organizational structure',
            jobEvaluation: 'Job evaluation',

            requestRoute: 'Type of request',
            region: 'Region',
            city: 'City',
            storeCode: 'Store',
            store: 'Store',
            directorateEngl: 'Directorate',
            unitEngl: 'Unit',
            divisionEngl: 'Division',
            department: 'Department',

            positionCurrent: 'Changed position',
            positionNew: 'New position in structure',
            positionCatalogNumber: 'Catalog number',
            positionCopyNumber: 'Copy position number',

            positionId: 'Position code',
            positionTitle: 'Position title',
            position: 'Position title in Russian',
            positionEngl: 'Position title in English',
            positionCode: 'Position',
            initiator: 'Initiator',
            initiatorName: 'Initiator of request',
            chief: 'Hiring manager',
            chiefPosition: 'Hiring manager position',
            chiefCode: 'Hiring manager personal ID',
            occupationType: 'Contract type',
            employmentType: 'Full time\\Part time',
            chartOfWork: 'Work schedule',
            accessToPC: 'Access to computer',
            addVacation: 'Additional vacation',
            northVacation: 'Northern additional vacation',
            northVacationPlaceholder: 'Days',
            displacedEmployee: 'Replaced employee',
            positionIsVacant: 'Position vacant',
            positionPlace: 'Reason of Opening',
            positionDisplaced: 'Replace',
            positionVacanted: 'New',
            positionVacant: 'vacant',
            positionPlaced: 'replace',
            contractPeriod: 'Contract length',
            mobilePhone: 'Mobile',
            HRM: 'Store HRM',
            HQHRGeneralist: 'HR Generalist',
            HQHRBP: 'HR BP',
            recruiter: 'Recruiter',
            HRBPOperations: 'HR BP Operations',
            responsibilities: 'Responsibilities',
            requirements: 'Requirements',
            competenticies: 'Competencies',
            values: 'Values',
            documents: 'Documents',
            documentAttached: 'Attached documents',
            documentAttach: 'Attach document',
            positionCostCenters: 'Cost center',
            HQ: 'HQ\\Store 1000',
            positionGrade: 'Grade',
            positionLevel: 'Level',
            salaryLevel: 'Salary level (min)',
            salaryLevelMid: 'Salary level (mid)',
            bonusScheme: 'Bonus scheme',
            bonusSchemePercent: '% of bonus scheme',
            familyDMS: 'Insurance for family members',
            companyCar: 'Corporate car',
            travellingWork: 'Travelling nature of work',
            liabilityContract: 'Material liability',
            positionBudgeted: 'Budgeted',
            approval: 'Approval',
            positionIsInCatalog: 'Position is in catalog',
            positionIsInOrgstr: 'Position is in orgstructure',
            positionIsInSAP: 'Position is in SAP',
            functionCode: 'Functional code of department',
            cellId: 'Cell code of Staff Schedule',
            staffPosition: 'Staff positions',
            cellIdDescription: 'Current position information',
            searchCellId: 'Load position description',
            competences: 'Competences',
            comment: 'Comment',
            comments: 'Comments',
            noComments: 'No comments',
            departmentsEmpty: 'No departments found',

            draftSave: 'Request successfuly saved in drafts',
            documentSave: 'Document attached',
            documentError: 'Unable to attach document',
            changesSave: 'Changes successfuly saved in request',
            sended: 'Request successfuly sended',
            createRoute: 'Create default route',
            approved: 'Request successfully approved',

            routes: {
                mgl: 'MGL',
                hq: 'HQ',
                store: 'Store',
            },

            approvals: {
                aco: 'ACO',
                cnb: 'C&B',
                cnbrate: 'C&B',
                back: 'BackOffice',
            },

            requestType: 'Find employee',
            types: {
                current: 'Position exist',
                new: 'Create new position',
                copy: 'Copy position',
            },

            changePosition: 'Add changes in position',

            copyOther: 'Cancel position copy',
            copyPositionPlaceholder: 'Choose position for copy',
            copyPosition: 'Position for copy',
            positionCodeApproval: 'Enter position code from SAP job catalogue',

            positionError: 'Cant load position description',
            noUnit: 'No',
            changePositionDescription: 'Please enter your proposal or leave the fields empty. Fields below require C&B evaluation.',
        },
        requestRoute: {
            title: 'Request approval route',
        },
        send: 'Send request',
        sendDocument: 'Attach document',
        save: 'Save request',
        saveDraft: 'Save draft',
        positionFields: 'Position requirements',
        position: 'Position',
        approvalRoute: 'Decision route',
        editApprovalRoute: 'Edir decision route',
        approvalHistory: 'Decision history',
    }
};
